export enum PlaygroundApi {
    GET_CONNECTOR = "/connector/simulator/playground",
    GET_SESSION_STARTED = "/session/list/playground",
    GET_SESSION = "/session/list/playground"
  }
  
